import React, { Component } from "react";
import ReactDOM from "react-dom";
import { MuiThemeProvider, createMuiTheme } from "material-ui/styles";
import registerServiceWorker from "utils/registerServiceWorker";
import App from "./App";
import pink from "material-ui/colors/pink";
import red from "material-ui/colors/red";

import "styles/main.css";

const theme = createMuiTheme({
  palette: {
    primary: red,
    secondary: red,
  },
});

export default class Root extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js